import React from 'react';

const RadioInput = ({
  name,
  label,
  isChecked,
  labelStyles,
  htmlFor,
  id,
  onChange,
  onClick,
}) => {
  return (
    <>
      <div className="flex items-start justify-start">
        <section className="flex items-center justify-start">
          <div className="border-2 border-secondary p-[1px] h-6 w-6 rounded-full flex items-center justify-center">
            <input
              type="radio"
              className=" checked:bg-secondary checked:text-secondary border-0 focus:outline-none focus:ring-0 inline-block rounded-full appearance-none"
              name={name}
              id={id} // htlmlFor targets this id.
              checked={isChecked}
              onClick={onClick}
            />
          </div>
        </section>
        <label htmlFor={htmlFor} className={[labelStyles, 'ml-4'].join(' ')}>
          <h3 className="font-medium text-xs lg:text-base text-neutral-600 ">
            {label}
          </h3>
        </label>
      </div>
    </>
  );
};

export default RadioInput;
